import React, { useContext, useEffect, useState } from "react";
import { MdSave, MdUpload } from "react-icons/md";
import { getTokenData } from "../../../../services/Auth__Service";
import {
  findOne,
  save as saveClient,
} from "../../../../services/Client__Service";
import { SIZE_IMAGE_UPLOAD, verifyPassword } from "../../../../services/config";
import { getfile } from "../../../../services/Document__Servive";
import { updatePassword } from "../../../../services/Settings__Service";
import { findOneByLogin, save } from "../../../../services/User__Service";
import navContext from "../../../Context/navContext";
import notifyContext from "../../../Context/notifyContext";
import Loader from "../../../Loader/Loader";
import { FORMER_JURIDIQUE } from "../../../../services/Constante.js";
import PhoneNumber from "../../../PhoneNumber/PhoneNumber";

const Profil = ({ clientId = 0 }) => {
  const notify = useContext(notifyContext);
  const [id, setId] = useState(clientId !== 0 ? clientId : 0);
  const [error, setError] = useState("");
  const [errorClient, setErrorClient] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [errorPasswordSecurity, setErrorPasswordSecurity] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUSer, setIsLoadingUser] = useState(true);
  const [isLoadingClient, setIsLoadingClient] = useState(true);

  const [client, setClient] = useState({
    id: 0,
    sigle: "",
    nom: "",
    email1: "",
    email2: "",
    tel1: "",
    tel2: "",
    nif: "",
    rccm: "",
    pays: 0,
    ville: "",
    adresse: "",
    statut: 1,
    formeJuridique: "",
    password: "",
    confirmpassword: "",
  });
  const [user, setUser] = useState({
    id: 0,
    nom: "",
    prenom: "",
    sexe: 1,
    date_naissance: "",
    email1: "",
    email2: "",
    tel1: "",
    tel2: "",
    pays: 0,
    ville: "",
    adresse: "",
    statut: 1,
    client: 0,
    profil: 0,
  });
  const nav = useContext(navContext);

  useEffect(() => {
    nav({
      links: [
        {
          href: "/client/profil",
          linkname: "Profil",
        },
      ],
      children: "",
    });

    if (id !== undefined && id > 0) {
      setIsLoading(true);
      fetchOneClient(id);
      const data = getTokenData();
      fetchOneUserByLogin(data.login);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];

    if (user.login === "") {
      display_errors.push({
        message: "Veuillez entrer le login",
        id_input: "login",
      });
    }

    if (user.nom === "") {
      display_errors.push({
        message: "Veuillez entrer le nom",
        id_input: "nom",
      });
    }
    if (user.email1 === "") {
      display_errors.push({
        message: "Veuillez entrer l'email 1",
        id_input: "email1",
      });
    }

    if (user.tel1 === "") {
      display_errors.push({
        message: "Veuillez entrer le téléphone 1",
        id_input: "tel1",
      });
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      save(user)
        .then(() => {
          setIsSend(false);
          notify("Enregistré avec succès", "success");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleSubmitClient = (e) => {
    e.preventDefault();

    let display_errors = [];

    if (client.sigle === "") {
      display_errors.push({
        message: "Veuillez entrer le sigle",
        id_input: "sigle",
      });
    }

    if (client.nom === "") {
      display_errors.push({
        message: "Veuillez entrer le nom",
        id_input: "nom",
      });
    }
    if (client.email1 === "") {
      display_errors.push({
        message: "Veuillez entrer l'email 1",
        id_input: "email1",
      });
    }

    if (client.tel1 === "") {
      display_errors.push({
        message: "Veuillez entrer le teléphone 1",
        id_input: "tel1",
      });
    }

    if (isFilePicked) {
      if (!selectedFile.type.includes("image/")) {
        display_errors.push({
          message: "Type de fichier incorrect. (Image autorisé)",
          id_input: "logo",
        });
      } else if (selectedFile.size > SIZE_IMAGE_UPLOAD) {
        display_errors.push({
          message:
            "Taille de fichier très grand (taille ne doit pas dépasser 1Mo)",
          id_input: "logo",
        });
      }
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setErrorClient(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      saveClient(
        isFilePicked
          ? { ...client, logo: selectedFile }
          : { ...client, logo: undefined }
      )
        .then((response) => {
          setIsSend(false);
          notify("Enregistré avec succès", "success");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleSubmitPassword = (e) => {
    e.preventDefault();

    let display_errors = [];
    let display_errors_security = [];

    if (client.password === "") {
      display_errors.push({
        message: "Veuillez entrer le mot de passe",
        id_input: "password",
      });
    } else {
      display_errors_security = verifyPassword(client.password);
      setErrorPasswordSecurity(
        display_errors_security.map((message, key) => {
          return <p key={key}>{message}</p>;
        })
      );
    }

    if (client.confirmpassword === "") {
      display_errors.push({
        message: "Veuillez entrer la confirmation du mot de passe",
        id_input: "confirmpassword",
      });
    } else if (client.confirmpassword !== client.password) {
      display_errors.push({
        message: "Les mots de passe ne sont pas identiques",
        id_input: "confirmpassword",
      });
    }

    display_errors.map(({ message, id_input }, key) => {
      return <label htmlFor={id_input}>{message}</label>;
    });

    setErrorPassword(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0 && display_errors_security.length === 0) {
      setIsSend(true);
      updatePassword(client.password)
        .then(() => {
          setIsSend(false);
          setClient((value) => {
            return {
              ...value,
              password: "",
              confirmpassword: "",
            };
          });
          notify("Modifié avec succès", "success");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setUser((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleChangeClient = (e) => {
    setClient((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };

  const fetchOneClient = async (idParams) => {
    findOne(idParams)
      .then((response) => {
        setClient((value) => {
          return {
            ...value,
            ...response.data,
            password: "",
            confirmpassword: "",
          };
        });
        fecthFile(response.data.logo);
        setIsLoadingClient(false);
      })
      .catch((error) => {
        setIsLoadingClient(false);
      });
  };

  useEffect(() => {
    if (!isLoadingClient && !isLoadingUSer) {
      setIsLoading(false);
    }
  }, [isLoadingClient, isLoadingUSer]);

  const fetchOneUserByLogin = async (login) => {
    findOneByLogin(login)
      .then((response) => {
        setUser({ ...response.data, login: response.data.compte.login });
        setIsLoadingUser(false);
      })
      .catch((error) => {
        setIsLoadingUser(false);
      });
  };

  const fecthFile = async (logo) => {
    getfile(logo, "image")
      .then((response) => {
        setSelectedFile(response.data);
        setIsLoadingClient(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  /* FILE HANDLE */
  const [selectedFile, setSelectedFile] = useState(); // contient des informations sur le fichier actuellement sélectionné.
  const [isFilePicked, setIsFilePicked] = useState(false); //détermine si un fichier a été sélectionné ou non.

  const handleChangeFile = (event) => {
    if (event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    }
  };

  /* FILE HANDLE END */
  useEffect(() => {
    if (error) {
      document.querySelectorAll("form .error")[0].scrollIntoView();
    }
  }, [error]);
  useEffect(() => {
    if (errorPassword) {
      document.querySelectorAll("form .error")[1].scrollIntoView();
    }
  }, [errorPassword]);
  useEffect(() => {
    if (errorClient) {
      document.querySelectorAll("form .error")[2].scrollIntoView();
    }
  }, [errorClient]);

  return (
    <div className="profil">
      <form className="form" onSubmit={handleSubmit}>
        <div className="form-header">
          <small>
            Les champs comportant <span className="required">*</span> sont
            obligatoires
          </small>
          <h3>Informations de l'utilisateur</h3>
          <div className="error">{error}</div>
        </div>

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="login" className="form-label">
              Login <span className="required">*</span> :
            </label>
            <p>{user.compte ? user.compte.login : ""}</p>
          </div>

          <div className="form-group">
            <label htmlFor="nom" className="form-label">
              Nom <span className="required">*</span> :
            </label>
            <input
              type="text"
              name="nom"
              id="nom"
              className="form-input"
              value={user.nom}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="prenom" className="form-label">
              Prénom (s) :
            </label>
            <input
              type="text"
              name="prenom"
              id="prenom"
              className="form-input"
              value={user.prenom}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email1" className="form-label">
              Email 1 <span className="required">*</span> :
            </label>
            <input
              type="email"
              name="email1"
              id="email1"
              className="form-input"
              value={user.email1}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email2" className="form-label">
              Email 2 :
            </label>
            <input
              type="email"
              name="email2"
              id="email2"
              className="form-input"
              value={user.email2}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="tel1" className="form-label">
              Téléphone 1 <span className="required">*</span> :
            </label>
            <PhoneNumber
              name="tel1"
              id="tel1"
              state={user.tel1}
              setState={setUser}
            />
          </div>

          <div className="form-group">
            <label htmlFor="tel2" className="form-label">
              Téléphone 2 :
            </label>
            <PhoneNumber
              name="tel2"
              id="tel2"
              state={user.tel2}
              setState={setUser}
            />
          </div>

          <div className="form-group">
            <label htmlFor="">Sexe : </label>
            <div
              style={{
                display: "grid",
                alignItems: "center",
                gridTemplateColumns: "auto auto",
                columnGap: "10px",
              }}
            >
              <label
                htmlFor="masculin"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className="form-label"
              >
                <input
                  type="radio"
                  name="sexe"
                  id="masculin"
                  className="form-input"
                  value="1"
                  onChange={handleChange}
                  checked={parseInt(user.sexe) === 1}
                />
                Masculin
              </label>
              <label
                htmlFor="feminin"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className="form-label"
              >
                <input
                  type="radio"
                  name="sexe"
                  id="feminin"
                  className="form-input"
                  value="0"
                  onChange={handleChange}
                  checked={parseInt(user.sexe) === 0}
                />
                Féminin
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="date_naissance" className="form-label">
              Date de naissance :
            </label>
            <input
              type="date"
              name="date_naissance"
              id="date_naissance"
              className="form-input"
              value={user.date_naissance}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="pays" className="form-label">
              Pays :
            </label>
            <select
              name="pays"
              id="pays"
              className="form-select"
              value={user.pays}
              onChange={handleChange}
            >
              <option value="0" disabled>
                Sélectionner un pays
              </option>
              <option value="1">Cameroun</option>
              <option value="2">Gabon</option>
              <option value="3">Congo</option>
              <option value="4">Tchad</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="ville" className="form-label">
              Ville :
            </label>
            <input
              type="text"
              name="ville"
              id="ville"
              className="form-input"
              value={user.ville}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="adresse" className="form-label">
              Adresse :
            </label>
            <textarea
              name="adresse"
              id="adresse"
              cols="50"
              rows="100"
              className="form-text-area"
              value={user.adresse}
              onChange={handleChange}
              wrap="true"
            ></textarea>
          </div>
        </div>

        <div className="form-footer">
          <button type="submit" className="btn">
            <MdSave />
            Enregistrer
          </button>
        </div>
      </form>

      <form className="form" onSubmit={handleSubmitPassword}>
        <div className="form-header">
          <h3>Changer le mot de passe</h3>
          <div className="error">{errorPassword}</div>
        </div>

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Mot de passe <span className="required">*</span> :
            </label>
            <input
              type="password"
              name="password"
              id="password"
              className="form-input"
              value={client.password}
              onChange={handleChangeClient}
            />
            <div className="error">{errorPasswordSecurity}</div>
          </div>
          <div className="form-group">
            <label htmlFor="confirmpassword" className="form-label">
              Confirmer le mot de passe <span className="required">*</span> :
            </label>
            <input
              type="password"
              name="confirmpassword"
              id="confirmpassword"
              className="form-input"
              value={client.confirmpassword}
              onChange={handleChangeClient}
            />
          </div>
        </div>
        <div className="form-footer">
          <button type="submit" className="btn">
            <MdSave />
            Enregistrer
          </button>
        </div>
      </form>

      <form className="form" onSubmit={handleSubmitClient}>
        <div className="form-header">
          <h3>Information de la société</h3>
          <div className="error">{errorClient}</div>
        </div>

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="nom" className="form-label">
              Nom <span className="required">*</span> :
            </label>
            <input
              type="text"
              name="nom"
              id="nom"
              className="form-input"
              value={client.nom}
              onChange={handleChangeClient}
            />
          </div>
          <div className="form-group">
            <label htmlFor="sigle" className="form-label">
              Sigle <span className="required">*</span> :
            </label>
            <input
              type="text"
              name="sigle"
              id="sigle"
              className="form-input"
              value={client.sigle}
              onChange={handleChangeClient}
            />
          </div>
          <div className="form-group">
            <label htmlFor="email1" className="form-label">
              Email 1 <span className="required">*</span> :
            </label>
            <input
              type="email"
              name="email1"
              id="email1"
              className="form-input"
              value={client.email1}
              onChange={handleChangeClient}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email2" className="form-label">
              Email 2 :
            </label>
            <input
              type="email"
              name="email2"
              id="email2"
              className="form-input"
              value={client.email2}
              onChange={handleChangeClient}
            />
          </div>

          <div className="form-group">
            <label htmlFor="tel1" className="form-label">
              Téléphone 1 <span className="required">*</span> :
            </label>
            <PhoneNumber
              name="tel1"
              id="tel1"
              state={client.tel1}
              setState={setClient}
            />
          </div>

          <div className="form-group">
            <label htmlFor="tel2" className="form-label">
              Téléphone 2 :
            </label>
            <PhoneNumber
              name="tel2"
              id="tel2"
              state={client.tel2}
              setState={setClient}
            />
          </div>
          <div className="form-group">
            <label htmlFor="nif" className="form-label">
              NIF :
            </label>
            <input
              type="text"
              name="nif"
              id="nif"
              className="form-input"
              value={client.nif}
              onChange={handleChangeClient}
            />
          </div>
          <div className="form-group">
            <label htmlFor="rccm" className="form-label">
              RCCM :
            </label>
            <input
              type="text"
              name="rccm"
              id="rccm"
              className="form-input"
              value={client.rccm}
              onChange={handleChangeClient}
            />
          </div>
          <div className="form-group">
            <label htmlFor="pays" className="form-label">
              Pays :
            </label>
            <select
              name="pays"
              id="pays"
              defaultChecked={1}
              className="form-select"
              value={client.pays}
              onChange={handleChangeClient}
            >
              <option value="0" disabled>
                Sélectionner un pays
              </option>
              <option value="1">Cameroun</option>
              <option value="2">Gabon</option>
              <option value="3">Congo</option>
              <option value="4">Tchad</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="ville" className="form-label">
              Ville :
            </label>
            <input
              type="text"
              name="ville"
              id="ville"
              className="form-input"
              value={client.ville}
              onChange={handleChangeClient}
            />
          </div>
          <div className="form-group">
            <label htmlFor="adresse" className="form-label">
              Adresse :
            </label>
            <textarea
              name="adresse"
              id="adresse"
              cols="50"
              rows="100"
              className="form-text-area"
              value={client.adresse}
              onChange={handleChange}
              wrap="true"
            ></textarea>
          </div>

          <div className="form-group">
            <label htmlFor="formeJuridique" className="form-label">
              Forme Juridique :
            </label>
            <select
              name="formeJuridique"
              id="formeJuridique"
              className="form-select"
              value={client.formeJuridique}
              onChange={handleChangeClient}
            >
              <option value="">Sélectionner une forme Juridique</option>
              {FORMER_JURIDIQUE.map((elt, key) => {
                return (
                  <option key={key} value={elt}>
                    {elt}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="form-group previewImg">
          <label htmlFor="logo" className="form-label">
            Logo :
          </label>
          <input
            style={{
              display: "none",
            }}
            type="file"
            name="logo"
            id="logo"
            className="form-input-file"
            onChange={handleChangeFile}
            accept="image/*"
          />
          <label htmlFor="logo" className="previewImg__content">
            {selectedFile && (
              <img
                src={URL.createObjectURL(selectedFile)}
                alt="logo entreprise"
              />
            )}
          </label>
          <label htmlFor="logo" className="form-label btn">
            <MdUpload />
          </label>
        </div>

        <div className="form-footer">
          <button type="submit" className="btn">
            <MdSave />
            Enregistrer
          </button>
        </div>
      </form>
      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </div>
  );
};

export default Profil;
